import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'submitButton', 'successMessage', 'errorMessage']

  declare readonly formTarget: HTMLFormElement
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly successMessageTarget: HTMLElement
  declare readonly errorMessageTarget: HTMLElement

  async submit(event: Event) {
    event.preventDefault()

    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.setAttribute('aria-busy', 'true')
    this.errorMessageTarget.classList.add('hidden')

    try {
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        body: new FormData(this.formTarget),
        headers: { Accept: 'application/json' },
        redirect: 'error',
      })

      if (response.ok) {
        this.formTarget.classList.add('hidden')
        this.successMessageTarget.classList.remove('hidden')
      } else {
        await this.showErrors(response)
        this.submitButtonTarget.disabled = false
        this.submitButtonTarget.removeAttribute('aria-busy')
      }
    } catch {
      this.errorMessageTarget.classList.remove('hidden')
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.removeAttribute('aria-busy')
    }
  }

  private async showErrors(response: Response) {
    try {
      const body = await response.json()
      if (body.errors?.length) {
        this.errorMessageTarget.textContent = body.errors.join(' · ')
        this.errorMessageTarget.classList.remove('hidden')
        return
      }
    } catch {
      // non-JSON body — fall through to default message
    }
    // reset to the CMS-configured default error message
    this.errorMessageTarget.textContent = this.errorMessageTarget.dataset.defaultMessage ?? ''
    this.errorMessageTarget.classList.remove('hidden')
  }
}
